import { injectable } from 'inversify';
import { ActionStates } from '../../Actions';

export type CommandAction = (from?: ActionStates, event?: any) => void;

let command: CommandStorage;
export function saveCmdInstance(cmd: CommandStorage): void {
  command = cmd;
}

export function emptyCmd(key: string): void {
  command[key] = [];
}

export function setCmd(
  key: string,
  action: CommandAction,
  clear = true
): void {
  if (clear) {
    emptyCmd(key);
  } else if (!command[key]) {
    command[key] = [];
  }
  command[key].push(action);
}

export function execCmd(key: string, from?: ActionStates, event?: any): void {
  if (command[key]) {
    for (const cmd of command[key]) {
      cmd(from, event);
    }
  }
}

@injectable()
export class CommandStorage {
  [key: string]: CommandAction[];
}
